import FeatureBlockAlpha from '~/editor/templates/alpha/FeatureBlockAlpha';
import type { FeatureBlockProps } from '~/editor/blocks/feature/FeatureBlockProps';
import { MicrositeTemplate } from '~/model';
import { type ComponentConfig } from '@puckeditor/core';
import { DEMO_FEATURES } from '~/demo';
import FeatureBlockBeta from '~/editor/templates/beta/FeatureBlockBeta';

export const PUCK_BLOCK_FEATURE: ComponentConfig<FeatureBlockProps> = {
	label: 'Feature',
	fields: {
		template: {
			type: 'select',
			label: 'Template',
			options: [
				{ label: 'Alpha', value: MicrositeTemplate.ALPHA },
				{ label: 'Beta', value: MicrositeTemplate.BETA },
			],
		},
		features: {
			type: 'array',
			label: 'Features',
			arrayFields: {
				item: {
					type: 'text',
					label: 'Feature',
				},
			},
		},
	},
	defaultProps: {
		template: MicrositeTemplate.ALPHA,
		features: [],
	},
	render: (props) => <FeatureBlock {...props} />,
};

export default function FeatureBlock({ template = MicrositeTemplate.ALPHA, ...props }: FeatureBlockProps) {
	const features = props.features.length > 0 ? props.features : DEMO_FEATURES;

	switch (template) {
		case MicrositeTemplate.BETA:
			return <FeatureBlockBeta features={features} template={template} />;
		case MicrositeTemplate.ALPHA:
		default:
			return <FeatureBlockAlpha features={features} template={template} />;
	}
}
